/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { ArrowLeftOutlined } from '@ant-design/icons'
import { App, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import styles from './index.less'
import { useFromPath } from '@/hooks/useFromPath'
import { CreateDatacloudForm } from '@/pages/dataCloud/features/CreateDatacloudForm'

export function CreateDataCloud() {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const { fromPath } = useFromPath()

  const createdCallback = () => {
    message.success(t('Data Cloud Created Successfully'))
    window.location.href = `/dataclouds`
  }

  return (
    <div className={classNames([styles.container, 'common-card'])}>
      <CreateDatacloudForm
        title={<h2 className="center-center">{t('Create Data Cloud')}</h2>}
        cancelButton={
          <Link to={fromPath}>
            <Button icon={<ArrowLeftOutlined />}>{t('Back')}</Button>
          </Link>
        }
        createdCallback={createdCallback}
      />
    </div>
  )
}
